import { useStore } from "../../store/store";
import { useRequiredMsgs } from "../../store/requiredMsgs";

function useFixedPanelProfileSelector() {
  const addToQuote = useStore((state) => state.addToQuote);

  const findRequired = useRequiredMsgs((state) => state.findRequired);
  const removeRequired = useRequiredMsgs((state) => state.removeRequired);

  const exactConfig = useStore((state) => state.quote.exactConfig);

  const stilesRailsProfile = useStore(
    (state) => state.quote.stilesRailsProfile
  );

  const fullboundProfile = useStore((state) => state.quote.fullboundProfile);

  const isDirectGlaze = exactConfig === "Direct Glaze";

  const handleClick = (label: string) => {
    const checked = checkMark(label);

    let update = { stilesRailsProfile: !checked ? label : "" };

    if (!checked && label === "Square") {
      update["stickingStops"] = "Square";
    }

    addToQuote(update, "stilesRailsProfile");

    const reqKey = isDirectGlaze ? "Frame Profile" : "Stiles and Rails Profile";

    if (!checked && findRequired(reqKey)) removeRequired(reqKey);
  };

  const handleClickFullbound = (label: string) => {
    const checked = checkMarkFullbound(label);

    addToQuote({ fullboundProfile: !checked ? label : "" }, "fullboundProfile");

    const reqKey = "Full Bound Profile";

    if (!checked && findRequired(reqKey)) removeRequired(reqKey);
  };

  const variant = (label: string) =>
    label === stilesRailsProfile ? "filled" : "outlined";

  const checkMark = (label: string) => label === stilesRailsProfile;

  const variantFullbound = (label: string) =>
    label === fullboundProfile ? "filled" : "outlined";

  const checkMarkFullbound = (label: string) => label === fullboundProfile;

  return {
    checkMark,
    checkMarkFullbound,
    variant,
    variantFullbound,
    handleClick,
    handleClickFullbound,
    isDirectGlaze,
    fullboundProfile,
    exactConfig,
    stilesRailsProfile
  };
}

export default useFixedPanelProfileSelector;
